export default __webpack_public_path__ + "80e54eec9e9cf0a46b0560901534a1bc.png";